import { NavLink } from "react-router-dom";
import styled from 'styled-components';

export const NavigationLink = styled(NavLink)`
  &.active li {
    color: #333;
    background-color: #f5f5f5;
    border-radius: 0.6rem;
  }
`;
